module.exports = __webpack_public_path__ + "img/logo_red.8f88eddc.png";